import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, ViewEncapsulation } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Router, RouterModule } from '@angular/router'
import { AnimationOptions } from 'ngx-lottie'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DictionaryService } from 'src/app/service/data/dictionary.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { BookmarkStateService } from 'src/app/service/state/bookmark-state.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { DdcButtonSOneComponent } from 'src/app/shared/ddc/ddc-button-s-one/ddc-button-s-one.component'
import { DdcButtonSTwoComponent } from 'src/app/shared/ddc/ddc-button-s-two/ddc-button-s-two.component'
import { DdcTextGradientComponent } from 'src/app/shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
import { Themes } from 'src/app/shared/enums/enums'
import { DdcButtonUOneComponent } from '../../shared/ddc/ddc-button-u-one/ddc-button-u-one.component'
@Component({
  selector: 'ddc-add-dialog-three',
  templateUrl: './ddc-add-dialog-three.component.html',
  styleUrl: './ddc-add-dialog-three.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcTextGradientComponent,
    DdcButtonUOneComponent,
    DdcButtonSOneComponent,
    DdcButtonSTwoComponent,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcAddDialogThreeComponent {
  _isSubscriptionError: boolean = false
  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  _theme: string
  _createdDic: any
  private themeSubscription: Subscription

  _isCreateBtnLoading = false
  _submitBtnText = 'Create'
  _titleMaxLength: number = 100
  _descriptionMaxLength: number = 1000
  _title: string = ''
  _addError: string = ''
  _addedField: string = ''
  _addedElementId: number
  _firstFieldTitle: string = ''
  _ownerUsername: string = ''

  _isDic: boolean = false
  _isCollection: boolean = false
  _titleIcon: string = ''

  _form = new FormGroup({
    // ! Title
    _title: new FormControl('', [Validators.required, Validators.maxLength(this._titleMaxLength)]),

    // ! Title
    _description: new FormControl('', [Validators.maxLength(this._descriptionMaxLength)]),
  })

  // This is the option that uses the package's AnimationOption interface
  options: AnimationOptions = {
    path: '/assets/lottie/green-tick-5.json',
    loop: false, // Set loop to false for a single playthrough
    autoplay: true,
  }

  constructor(
    private logger: DdcLoggerService,
    private router: Router,
    public themeService: ThemeService,
    public dic_service: DictionaryService,
    private bookmarkStateService: BookmarkStateService,
    private dialogRef: MatDialogRef<DdcAddDialogThreeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      if (data == 'dictionary') {
        this._title = 'Dictionary'
        this._isDic = true
        this._firstFieldTitle = 'Title'
        this._titleIcon = 'auto_stories'
      } else if (data == 'collection') {
        this._title = 'Collection'
        this._isCollection = true
        this._firstFieldTitle = 'Name'
        this._titleIcon = 'collections_bookmark'
      }
    }
    // this._selectedChipOptions = [data.targetChip]

    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  add(): void {
    this.logger.info('DdcAddDialogThreeComponent | add')

    // Prevent multiple submissions
    if (this._isCreateBtnLoading) {
      this.logger.info('DdcAddDialogThreeComponent | add | already loading, skipping')
      return
    }

    if (!this._form.valid) return

    this._isCreateBtnLoading = true
    this._submitBtnText = 'Creating...'

    if (this._isDic) {
      const element = {
        title: this._form.value._title,
        description: this._form.value._description,
      }

      this.dic_service.add_dic(element).subscribe((res: any) => {
        if (res.success) {
          this._addError = ''
          this._addedField = this._form.value._title
          this._addedElementId = res.res.id
          this._ownerUsername = res.res.owner.username
          this._createdDic = res.res
        } else {
          this.logger.error('DdcAddDialogThreeComponent | add | add_dic | failed: res: ' + res)
          this._addError = res.res['detail'] ? res.res['detail'] : res.res[0]
          if (this._addError.includes('subscribe')) this._isSubscriptionError = true
          this._addedField = ''
        }
        this._isCreateBtnLoading = false
        this._submitBtnText = 'Add'
      })
    } else if (this._isCollection) {
      const element = {
        name: this._form.value._title,
      }

      // Use the state service to create the bookmark group
      this.bookmarkStateService
        .createBookmarkGroup(element.name)
        .then(newBookmarkGroup => {
          // Success case
          this.logger.info(
            'DdcAddDialogThreeComponent | Collection created successfully:',
            newBookmarkGroup,
          )
          this._addError = ''
          this._addedField = newBookmarkGroup.name
          this._addedElementId = newBookmarkGroup.id
          this._isCreateBtnLoading = false
          this._submitBtnText = 'Create'

          // Close the dialog automatically after successful creation
          setTimeout(() => {
            this.closeDialog()
          }, 1000) // Close after 1 second to show success message briefly
        })
        .catch(error => {
          // Error case
          this.logger.error('DdcAddDialogThreeComponent | Failed to create collection:', error)
          this._addError = error.message || 'Failed to create collection'
          this._addedField = ''
          this._isCreateBtnLoading = false
          this._submitBtnText = 'Create'
        })
    }
  }

  openDic(id: number): void {
    this.logger.info('DdcAddDialogThreeComponent | openDic | id: ' + id)

    this.dialogRef.close('closeAll')
    const navigationUrl = `/library/dic/${id}/${this._ownerUsername}`

    this.router.navigate([navigationUrl])
  }

  closeDialog(): void {
    var target: String = ''
    var element: any = null

    if (this._isDic) {
      target = 'dictionary'
      element = this._createdDic
    } else if (this._isCollection && this._addedField && this._addedElementId) {
      // Only return collection data if it was successfully created
      target = 'collection'
      element = {
        id: this._addedElementId,
        name: this._addedField,
      }
    }

    this.dialogRef.close({ type: target, element: element })
  }

  get title(): any {
    return this._form.get('_title')
  }

  get description(): any {
    return this._form.get('_description')
  }
}
